<template>
  <div class="tg-store-home">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="title">{{ name }}</div>
    </div>

    <!-- 轮播图部分 -->
    <div class="banner-swiper">
      <swiper class="swiper" :options="dynamicSwiperOptions">
        <swiper-slide
          v-for="(banner, index) in bannerList"
          :key="index"
          :data-banner-index="index"
        >
          <img class="banner-img" :src="banner.banner" alt="专属福利商城" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <!-- 商城入口列表 -->
    <div class="store-entrance-list">
      <div
        class="store-entrance-item"
        v-for="(item, index) in storeList"
        :key="index"
      >
        <div class="entrance-left">
          <img class="store-icon" :src="item.icon" alt="商城图标" />
        </div>
        <div class="entrance-middle">
          <div class="store-name">{{ item.name }}</div>
          <div class="store-desc">{{ item.describe_info }}</div>
        </div>
        <div class="entrance-right">
          <van-button type="danger" class="go-btn" round @click="goToStore(item)"
            >去抢购</van-button
          >
        </div>
      </div>
    </div>

    <!-- 本周必买 -->
    <div class="weekly-must-buy">
      <div class="section-title">
        <img
          src="https://assets.hzwxbz2.cn/sy/hm/img/benzhoubimai.png"
          alt="本周必买"
          class="title-img"
        />
      </div>
      <div class="product-list">
        <div class="product-item" v-for="(item, index) in productList" :key="index">
          <div class="discount-tag">
            <i class="iconfont aci-shangcheng_biaoqian-copy"></i>
            <span>{{ item.discount }}</span>
          </div>
          <div class="product-img">
            <img :src="item.icon" alt="仙玉礼包" />
          </div>
          <div class="product-info">
            <div class="product-name">{{ item.name }}</div>
            <div class="product-desc">{{ item.intro }}</div>
            <div class="product-price">
              <div class="price-wrapper">
                <span class="current-price">¥{{ item.price }}</span>
                <span class="original-price">¥{{ item.original_price }}</span>
              </div>
              <div class="buy-btn" @click="goToProduct(item)">抢</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Button, Toast } from 'vant';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { getCollectionData, shopData } from '@/api/tgStore';

let vm = ''; // 定义全局变量用于在 swiper 回调中访问 Vue 实例

export default {
  name: 'TgStoreHome',
  components: {
    Swiper,
    SwiperSlide,
    [Icon.name]: Icon,
    [Button.name]: Button,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        loop: true,
        initialSlide: 1,
        preventClicks: false,
        on: {
          click(e) {
            let clickedSlide = e.target.closest('.swiper-slide');
            if (clickedSlide) {
              let realIndex = parseInt(clickedSlide.getAttribute('data-banner-index'));
              if (vm.bannerList && vm.bannerList[realIndex]) {
                vm.goToBanner(vm.bannerList[realIndex]);
              }
            }
          }
        }
      },
      // Mock数据 - Banner轮播图
      bannerList: [
      ],
      // Mock数据 - 商城列表
      storeList: [

      ],
      // Mock数据 - 商品列表
      productList: [
      ],
      name: '',
      pageId: '',
    };
  },
  computed: {
    // 根据banner数量动态配置swiper选项
    dynamicSwiperOptions() {
      return this.swiperOptions;
    }
  },
  created() {
    // 这里可以添加页面初始化的接口调用
    this.initData();
    // 将 Vue 实例赋值给全局变量，供 swiper 的 on 回调使用
    vm = this;
  },
  methods: {
    // 初始化数据
    initData() {
      const { id } = this.$route.query;
      this.pageId = id;
      getCollectionData({ id }).then((res) => {
        if (res.code === 1) {
          this.bannerList = res.data.banner;
          this.storeList = res.data.shop;
          this.productList = res.data.goods;
          this.name = res.data.name;
          shopData({
            type: 9,
            collection_page_id: id,
            collection_page_name: this.name,
          });
        }
      });
    },
    goToStore(item) {
      shopData({
        type: 11,
        collection_page_id: this.pageId,
        collection_page_name: this.name,
        config_id: item.id,
        config_name: item.name,
      });
      setTimeout(() => {
        this.$router.push({
          name: 'tgStore.store',
          query: {
            config_id: item.id,
          },
        });
      }, 200);
    },
    goToBanner(banner) {
      shopData({
        type: 10,
        collection_page_id: this.pageId,
        collection_page_name: this.name,
        banner_name: banner.name,
      });
      // 跳太快埋点会失败，所以需要延迟一下
      setTimeout(() => {
        // 1. 跳转到商城 2. 跳转链接
        if (banner.type === 1) {
          this.$router.push({
            name: 'tgStore.store',
            query: {
              config_id: banner.shop_good_config_id,
              tab_id: banner.goods_type,
              good_id: banner.shop_good_id,
            },
          });
        } else if (banner.type === 2) {
          window.open(banner.url, '_self');
        }
      }, 200); // 延长延迟时间到 500ms，确保埋点请求完成
    },
    // 返回上一页
    goBack() {
      this.$router.back();
    },

    // 跳转到商品详情
    goToProduct(item) {
      shopData({
        type: 12,
        collection_page_id: this.pageId,
        collection_page_name: this.name,
        config_id: item.shop_good_config_id,
        config_name: item.shop_good_config_name,
        second_shop_id: item.goods_type,
        second_shop_name: item.second_shop_name,
        good_id: item.id,
        good_name: item.name,
      });
      setTimeout(() => {
        this.$router.push({
          name: 'tgStore.store',
          query: {
            config_id: item.shop_good_config_id,
            tab_id: item.goods_type,
            good_id: item.id,
          },
        });
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
.tg-store-home {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 50px;
  .header {
    display: flex;
    align-items: center;
    height: 44px;
    background-color: #fff;
    position: relative;
    padding: 0 15px;

    .back-icon {
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
    }

    .title {
      flex: 1;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
    }
  }

  .banner-swiper {
    position: relative;
    width: 95%;
    height: 205px;
    margin: 5px auto;
    overflow: hidden;
    border-radius: 8px;

    .swiper {
      width: 100%;
      height: 100%;
    }

    .banner-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    :deep(.swiper-pagination-bullet) {
      width: 6px;
      height: 6px;
      background-color: #fff;
      opacity: 0.6;
      margin: 0 4px;
    }

    :deep(.swiper-pagination-bullet-active) {
      opacity: 1;
    }
  }

  .store-entrance-list {
    padding: 10px 15px;

    .store-entrance-item {
      display: flex;
      align-items: center;
      background-color: #fff;
      border-radius: 8px;
      padding: 12px;
      margin-bottom: 8px;

      .entrance-left {
        width: 60px;
        height: 60px;
        margin-right: 12px;

        .store-icon {
          width: 100%;
          height: 100%;
          border-radius: 8px;
        }
      }

      .entrance-middle {
        flex: 1;

        .store-name {
          font-size: 16px;
          width: 160px;
          font-weight: 500;
          color: #333;
          margin-bottom: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .store-desc {
          font-size: 14px;
          color: #f38f3e;
          max-width: 160px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .entrance-right {
        .go-btn {
          padding: 0 20px;
          height: 32px;
          font-size: 14px;
        }
      }
    }
  }

  .weekly-must-buy {
    padding: 10px 15px 15px;
    background: linear-gradient(0deg, #fcf6ff 0%, #fceced 100%), #ffffff;
    border-radius: 8px;
    margin: 0px 15px;

    .section-title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .title-img {
        height: 20px;
        object-fit: contain;
      }
    }

    .product-list {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -5px;

      .product-item {
        width: calc(50% - 10px);
        margin: 0 5px 10px;
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        .discount-tag {
          position: absolute;
          top: -15px;
          right: 0px;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            font-size: 50px;
            color: #ffd57a;
            // 前后翻转
            transform: rotateY(180deg);
          }

          span {
            position: absolute;
            z-index: 11;
            color: #b25900;
            font-size: 12px;
            margin-left: 6px;
          }
        }

        .product-img {
          width: 100%;
          height: 0;
          padding-bottom: 80%;
          position: relative;

          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: fill;
          }
        }

        .product-info {
          padding: 10px 4px;

          .product-name {
            font-size: 12px;
            font-weight: 500;
            color: #333;
            margin-bottom: 5px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .product-desc {
            font-size: 10px;
            color: #999;
            margin-bottom: 8px;
            height: 28px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 1.5;
          }

          .product-price {
            display: flex;
            align-items: center;
            background: #fef3ee;
            border-radius: 12px;
            padding: 0 5px {
              right: 0;
            }
            .price-wrapper {
              display: flex;
              align-items: flex-end;
              flex: 1;
            }

            .current-price {
              font-size: 16px;
              font-weight: 500;
              color: #f44;
              line-height: 1;
            }

            .original-price {
              font-size: 9px;
              color: #999;
              text-decoration: line-through;
              margin-left: 5px;
              line-height: 1;
            }

            .buy-btn {
              width: 50px;
              height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: url('https://assets.hzwxbz2.cn/sy/hm/img/button.png') no-repeat;
              background-size: 100% 100%;
              color: #fff;
              font-size: 15px;
              padding-left: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
